import { KeyframeGeography } from "lib/types/KeyframeGeography";
import { DEFAULT_PRIMARY_MARKER_SCALE } from "components/elements/CesiumViewer/core/utils/generatePrimaryMarker";

export const processProjectMapMarkers = (
  geography: KeyframeGeography,
): KeyframeGeography => {
  return (
    geography && {
      ...geography,
      features: geography?.features.map((feature) => {
        const {
          properties: { markerScale },
        } = feature;
        return {
          ...feature,
          properties: {
            ...feature.properties,
            markerScale: markerScale ?? DEFAULT_PRIMARY_MARKER_SCALE,
            markerColor: "#17eb69",
            entityType: "project",
          },
        };
      }),
    }
  );
};
